module.exports = __webpack_public_path__ + "static/media/S (85).93b87c2b.jpg";